import React from 'react';
import PropTypes from 'prop-types';
import InputDate from 'components/FormElements/InputDateControlled';
import { withLocale } from '@dietlabs/components';
import apiDateFormat from 'components/Helpers/apiDateFormat';
import withStep from './StepContext/withStep';

const MIN_DATE_DAYS_IN_FUTURE = 1;
const MAX_DATE_DAYS_IN_FUTURE = 14;

const getDateStringDaysInFuture = days => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return apiDateFormat(date);
};

const getMinDateString = () =>
    getDateStringDaysInFuture(MIN_DATE_DAYS_IN_FUTURE);
const getMaxDateString = () =>
    getDateStringDaysInFuture(MAX_DATE_DAYS_IN_FUTURE);

class StepSexBirthdayHeight extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        startDate: PropTypes.string,
        handleInputChange: PropTypes.func.isRequired,
        changeNextBtnState: PropTypes.func.isRequired,
        errors: PropTypes.shape(),
        validateData: PropTypes.func.isRequired,
    };

    static defaultProps = {
        startDate: undefined,
        errors: undefined,
    };

    componentDidMount() {
        this.checkErrors();
    }

    componentDidUpdate() {
        this.checkErrors();
    }

    checkErrors = () => {
        let errors = false;

        if (this.props.errors) {
            this.props.errors.details.forEach(error => {
                if (error.fieldName === 'startDate') {
                    errors = true;
                }
            });
        }

        this.props.changeNextBtnState(!(this.props.startDate && !errors));
    };

    render() {
        const { startDate, handleInputChange, errors } = this.props;

        return (
            <div className="full-screen3">
                <div className="mb-auto w-100">
                    <InputDate
                        label={this.props.t(
                            'diet-settings/final/start-date-question'
                        )}
                        name="startDate"
                        value={startDate}
                        min={getMinDateString()}
                        max={getMaxDateString()}
                        errors={errors}
                        handleChange={handleInputChange}
                        onBlur={() => this.props.validateData()}
                        data-test="start-date-input"
                    />

                    <p>Czym kierować się przy rozpoczęciu diety?</p>
                    <ul>
                        <li>
                            zaplanuj czas na dokonanie zakupów potrzebnych do
                            diety
                        </li>
                        <li>
                            jeżeli planujesz wyjazd, który uniemożliwi Ci
                            zastosowanie się do jadłospisu, przełóż start diety
                            na dogodniejszy termin
                        </li>
                        <li>
                            nie odwlekaj terminu rozpoczęcia diety — pierwszy
                            krok już za Tobą, idź śmiało dalej
                        </li>
                        <li>masz 15 dni na rozpoczęcie swojej diety</li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default withStep(withLocale(StepSexBirthdayHeight));
